import React from "react";
import { Modal } from "./Modal"

interface Props extends Omit<React.HTMLAttributes<HTMLAnchorElement>, "onClick"> {
    modalContent: React.ReactNode;
    header?: React.ReactNode;
    verticallyCenteredModal?: boolean;
    onShow?: () => void;
    onHide?: () => void;
    forceReload?: boolean;
    size?: "sm" | "lg" | "xl" | "fullscreen"
}

export class OpenModalLink extends React.Component<Props> {
    private modalRef = React.createRef<Modal>();

    private click = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        this.modalElement().open();
        this.forceUpdate();
    }

    private modalElement() {
        return this.modalRef.current!;
    }

    public close() {
        this.modalElement().close();
    }

    render() {
        const { modalContent, header, verticallyCenteredModal, forceReload, onShow, onHide, ...buttonProps } = this.props;

        return (
            <>
                <a
                    {...buttonProps}
                    onClick={this.click}
                />
                <Modal ref={this.modalRef}
                    forceReload={forceReload}
                    verticallyCentered={verticallyCenteredModal}
                    onHide={onHide}
                    onShow={onShow}
                    header={header}
                    size={this.props.size}
                >
                    {this.props.modalContent}
                </Modal>
            </>
        );
    }
}

export default OpenModalLink;